/**
 * @fileoverview Conversas: quem vê as conversas dos atendentes (só as
 * próprias, as das filas dele ou as da empresa toda) e, com a regra nova
 * ligada, as dos Supervisores (as das filas dele ou as da empresa toda, nunca
 * menos que os atendentes). O servidor confere a mesma regra
 * (services/TicketServices/ticketScope.ts no backend).
 */

import React from "react";

import SettingsSection from "../../../components/Settings/SettingsSection";
import SettingItem from "../../../components/Settings/SettingItem";
import { i18n } from "../../../translate/i18n";
import { bindSetting } from "../useSettingsArea";
import { findItem, visibleFields } from "../registry";

const t = (field, key) => i18n.t(`settings.sections.conversations.fields.${field}.${key}`);

const Conversations = ({ area, ctx }) => {
  const fields = visibleFields(findItem("conversations"), ctx).map((field) => field.id);
  return (
    <SettingsSection>
      <SettingItem
        {...bindSetting(area, "ticketVisibility", "queues")}
        title={t("ticketVisibility", "title")}
        description={t("ticketVisibility", "description")}
        options={[
          { value: "own", label: t("ticketVisibility", "options.own") },
          { value: "queues", label: t("ticketVisibility", "options.queues") },
          { value: "company", label: t("ticketVisibility", "options.company") },
        ]}
      />
      {fields.includes("supervisorTicketVisibility") && (
        <SettingItem
          {...bindSetting(area, "supervisorTicketVisibility", "queues")}
          title={t("supervisorTicketVisibility", "title")}
          description={t("supervisorTicketVisibility", "description")}
          options={[
            { value: "queues", label: t("supervisorTicketVisibility", "options.queues") },
            { value: "company", label: t("supervisorTicketVisibility", "options.company") },
          ]}
        />
      )}
    </SettingsSection>
  );
};

export default Conversations;
